import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { bookingdashboard, BookingOverview, dashboard, MonthlyRevenue } from 'src/app/Models/dashboard';
import { UsersService } from 'src/app/Services/users.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild('barChartCanvas') barChartCanvas!: ElementRef;
  @ViewChild('bookingChartCanvas') bookingChartCanvas!: ElementRef;
 
 dashboardData: Partial<dashboard> = {};
 bookingrdData: Partial<bookingdashboard>={}
 
constructor(private dashdata:UsersService){}


  ngOnInit(): void {
    this.showdashboraddata();
    this.bookingshowdashboraddata()
   
  }


  ngAfterViewInit(): void {
 this.LoadBookinggraph();
    this.loadRevenueGraph();
    
  }

  totalRevenue: number = 0;
  growthRate: number | null = null;
private renderRevenueChart(labels: string[], dataValues: number[]): void {
  const maxValue = Math.max(...dataValues);
  const step = Math.ceil(maxValue / 5 / 1000) * 1000; // nice rounded step size

  const data = {
    labels,
    datasets: [
      {
        label: 'Revenue',
        data: dataValues,
        backgroundColor: 'rgba(46, 204, 113, 0.85)',
        borderColor: 'rgba(46, 204, 113, 1)',
        borderWidth: 1,
        borderRadius: 10,
        barPercentage: 0.4,
        categoryPercentage: 0.8,
      },
    ],
  };

  new Chart(this.barChartCanvas.nativeElement, {
    type: 'bar',
    data,
    options: {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => `$${tooltipItem.raw}`,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: step,
            callback: (value) => `$${(+value / 1000).toFixed(0)}k`,
          },
        },
        x: {
          ticks: { autoSkip: false },
        },
      },
    },
  });
}



loadRevenueGraph(): void {
  this.dashdata.getMonthlyRevenue().subscribe((res: MonthlyRevenue) => {
    this.renderRevenueChart(res.months, res.amount);
    this.totalRevenue = res.totalRevenue;
    this.growthRate = res.growthRate;
  });
}

 private renderBookingChart(labels: string[], dataValues: number[]): void {
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Bookings',
        data: dataValues,
        backgroundColor: '#FFBF38', 
        borderColor: '#FFBF38',
        borderWidth: 1,
        borderRadius: 10,
        barPercentage: 0.4,
        categoryPercentage: 0.8,
      },
    ],
  };

  new Chart(this.bookingChartCanvas.nativeElement, {
    type: 'bar',
    data: data,
    options: {
      responsive: true,
      plugins: {
        legend: { display: false },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 50,
            callback: (value) => `${value} bookings`,
          },
        },
      },
    },
  });
}

LoadBookinggraph() {
  debugger;
  this.dashdata.getBookingOverview().subscribe((res: BookingOverview) => {

    this.renderBookingChart(res.months, res.bookingCount);
  });
}
showdashboraddata()
{
this.dashdata.getUserDashboardData().subscribe((res)=>{

this.dashboardData=res


})
 

}



bookingshowdashboraddata()
{
this.dashdata.getbookingDashboardData().subscribe((res)=>{

this.bookingrdData=res


})
 

}

}